import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: 130px;
`



// WEBPACK FOOTER //
// ./src/app/elements/ChooseGeneralInformation/styles.js